import React from 'react';

import { Layout } from '@components/Layout';
import { useGenerateStatusError } from '@hooks/queries/useGenerateError';

export const TestStatusError500: React.FC = () => {
  const generateError = useGenerateStatusError(500);

  return (
    <Layout
      title="TestStatusError500"
      loading={generateError.isLoading}
      errors={[generateError.error]}
    >
      {null}
    </Layout>
  );
};
